/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import moment from "moment";
import React, { useEffect, useState } from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  CardTitle,
  Table,
  Row,
  Col,
  ButtonGroup,
} from "reactstrap";
import { useHistory } from "react-router";
import withReactContent from "sweetalert2-react-content";
import Cookies from "universal-cookie";
import api from "../../utils/axiosApi";
import { option, Toast } from "../../utils/sweetalert";

const cookies = new Cookies();

function Tables() {
  const history = useHistory();

  const [calendarios, setCalendarios] = useState([]);
  const [pages, setPages] = useState({
    actualPage: 0,
    maxPages: 1,
  });

  useEffect(() => {
    const requestcalendarios = async () => {
      try {
        const localToken =
          window.sessionStorage.getItem("jwtuser") ||
          localStorage.getItem("jwtuser");
        const resp = await api.get("/backoffice/agenda-calendar", {
          headers: {
            Authorization: `Bearer ${localToken}`,
          },
        });
        setCalendarios(resp.data.data);
        const cantPag = resp.data.meta.page["last-page"];
        setPages((prev) => ({ ...prev, maxPages: cantPag }));
      } catch (error) {
        //console.log(error)
      }
    };
    requestcalendarios();
  }, []);

  const handleDelete = async (c) => {
    const MySwal = withReactContent(option);
    const resp = await MySwal.fire({
      title: (
        <p style={{ fontSize: "22px", zIndex: 30000 }}>
          Desea Eliminar Completamente este Calendario?
        </p>
      ),
      text: "Presione eliminar para continuar o presione afuera para salir",
      confirmButtonText: "Eliminar",
      icon: "question",
      focusConfirm: false,
    });
    if (resp.isConfirmed) {
      try {
        const respbd = await api.delete(`/agendacalendar/delete/${c._id}`, {
          headers: {
            Authorization: `Bearer ${cookies.get("jwtuser")}`,
          },
        });
        if (!respbd.data.error) {
          const calendarioscopy = [...calendarios];
          const ideliminar = calendarioscopy.findIndex((element) => {
            return element._id === c._id;
          });
          calendarioscopy.splice(ideliminar, 1);
          setCalendarios(calendarioscopy);
          const MySwal = withReactContent(Toast);
          await MySwal.fire({
            title: (
              <p style={{ fontSize: "1.5rem" }}>
                calendar eliminado Exitosamente
              </p>
            ),
            icon: "success",
          });
        } else {
          const MySwal = withReactContent(Toast);
          await MySwal.fire({
            title: <p style={{ fontSize: "1.5rem" }}>Password invalida</p>,
            icon: "error",
          });
        }
      } catch (error) {
        //console.log(error)
      }
    }
  };

  const nextPage = async () => {
    if (pages.actualPage > pages.maxPages) {
      return;
    }
    const nextPage = pages.actualPage + 1;
    setPages({ ...pages, actualPage: nextPage });
    const respcountry = await api.get(
      `/backoffice/agenda-calendar?PagNumber=${nextPage}`
    );
    setCalendarios(respcountry.data.data);
  };

  const PrevPage = async () => {
    if (pages.actualPage === 0) {
      return;
    }
    const nextPage = pages.actualPage - 1;
    setPages({ ...pages, actualPage: nextPage });
    const respcountry = await api.get(
      `/backoffice/agenda-calendar?PagNumber=${nextPage}`
    );
    setCalendarios(respcountry.data.data);
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col className="pr-md-1" md="6">
                    <CardTitle tag="h4">Calendarios</CardTitle>
                    <Button
                      color="info"
                      size="sm"
                      style={{ marginTop: "10px" }}
                      onClick={() => history.push("/admin/vendidos")}
                    >
                      Ver Calendarios Vendidos
                    </Button>
                  </Col>
                  <Col className="pr-md-1" md="6">
                    <ButtonGroup>
                      <Button onClick={PrevPage}>Anterior</Button>
                      <Button disabled>
                        {pages.actualPage + 1} de {pages.maxPages}
                      </Button>
                      <Button onClick={nextPage}>Siguiente</Button>
                    </ButtonGroup>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody style={{ overflowX: "auto" }}>
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>Ubicación</th>
                      <th className="text-center">Cantidad de Actividades</th>
                      <th>Última Edición</th>
                      <th className="text-center">Fecha de Inicio</th>
                      <th className="text-center">Creador</th>
                      <th className="text-center">Clonaciones</th>
                      <th className="text-center">Es Gratis</th>
                      <th className="text-center">Costo</th>
                      <th className="text-center">Moneda</th>
                      <th className="text-center">Eliminar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {calendarios.map((c, i) => {
                      const isModelCalendar =
                        c.cloned_count !== undefined &&
                        c.isFree !== undefined &&
                        c.cost !== undefined &&
                        c.currency !== undefined;
                      return (
                        <tr key={`calendars-${i}`}>
                          <td>{c.name}</td>
                          <td className="text-center">
                            {c.agendaItems.length}
                          </td>
                          <td>{moment().diff(c.updatedAt, "days")} días</td>
                          <td className="text-center">
                            {moment(c.startDate).format("YYYY-MM-DD")}
                          </td>
                          <td className="text-center">
                            {
                            c.creator
                              ? c.creator.email
                              : c.users.length > 0
                              ? c.users[0].email
                              : "sin creador"
                            }
                          </td>
                          <td className="text-center">
                            {isModelCalendar
                              ? c.cloned_count
                              : "Calendario Regular"}
                          </td>
                          <td className="text-center">
                            {isModelCalendar
                              ? c.isFree
                                ? "Sí"
                                : "No"
                              : "Calendario Regular"}
                          </td>
                          <td className="text-center">
                            {isModelCalendar ? c.cost : "Calendario Regular"}
                          </td>
                          <td className="text-center">
                            {isModelCalendar ? c.currency : "Calendario Regular"}
                          </td>
                          <td className="text-center">
                            <Button
                              onClick={() => {
                                handleDelete(c);
                              }}
                              size="sm"
                              type="button"
                              color="danger"
                            >
                              Eliminar
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Tables;
